import React from 'react'
import { Step, SingleAnswer } from '../../components'

const HEARING = {
  key: 'hear_of_mote',
  trackingKey: 'how_heard',
  question: 'How did you hear about Mote?',
  choices: [
    {
      icon: '👩‍',
      text: 'Recommended by a colleague',
      value: 'colleague_recommended'
    },
    {
      icon: '🏫',
      text: 'Encouraged by school or district',
      value: 'enc_school'
    },
    { icon: '📱', text: 'Social media', value: 'social' },
    { icon: '🌐', text: 'Web search', value: 'web' },
    { icon: '🎟️', text: 'Event/Conference', value: 'event' },
    { text: 'Other', value: 'other' }
  ]
}

export const HearAbout = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={HEARING.trackingKey}
      itemsCount={HEARING.choices.length}
      title={HEARING.question}
      subtitle='Select one (Required)'
    >
      {HEARING.choices.map(({ icon, text, value }) => (
        <SingleAnswer
          key={`${text}-${value}`}
          question={HEARING.question}
          surveyKey={HEARING.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
